import React, { useEffect, useState } from "react";
import { api } from "../../api";
import { KIND_TAG, eventSentence, outcomeLine, stamp } from "./bookingFormat";

/*
 * TAB 4: LOG. Every event, newest first. "Time taken" and "Calendar error"
 * are diagnostics, not alarms: dashed grey tags and a line saying what
 * happened next.
 */

const CHIPS = [
  ["booked", "Booked"],
  ["moved", "Moved"],
  ["agenda_changed", "Agenda"],
  ["note_changed", "Note"],
  ["guest_added", "Guests"],
  ["cancelled", "Cancelled"],
  ["slot_taken", "Time taken"],
  ["calendar_error", "Calendar errors"],
];

export default function BookingLogTab({ data, days }) {
  const zone = data.calendar.timezone;
  const agendas = data.settings.agendas;
  const [kind, setKind] = useState(null);
  const [limit, setLimit] = useState(50);
  const [rows, setRows] = useState(null);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api(`/booking/events?limit=${limit}${kind ? `&kind=${kind}` : ""}`)
      .then(setRows)
      .catch(() => setRows([]));
  }, [kind, limit]);

  useEffect(() => {
    api(`/booking/event-counts?days=${days}`).then(setCounts).catch(() => setCounts({}));
  }, [days]);

  return (
    <div className="crm-bklog">
      <div className="crm-bklog__chips">
        {CHIPS.map(([key, label]) => (
          <button
            key={key}
            type="button"
            className={`crm-bklog__chip${kind === key ? " sel" : ""}${kind && kind !== key ? " is-dim" : ""}`}
            onClick={() => {
              setKind(kind === key ? null : key);
              setLimit(50);
            }}
          >
            {label} <span>{counts[key] || 0}</span>
          </button>
        ))}
        <span className="crm-hint crm-bklog__order">Newest first</span>
      </div>
      <p className="crm-hint">
        "Time taken" means two people went for the same slot and one got it first. "Calendar error" means Google refused a
        write. Both are diagnostics. Nothing to do unless they repeat.
      </p>

      <div className="crm-card crm-bklog__list">
        {!rows ? (
          <p className="crm-hint">Loading…</p>
        ) : !rows.length ? (
          <p className="crm-hint">Nothing logged yet.</p>
        ) : (
          rows.map((e) => {
            const tag = KIND_TAG[e.kind] || { label: e.kind, cls: "" };
            const s = eventSentence(e, { zone, agendas });
            const diag = outcomeLine(e, zone);
            return (
              <div key={e.id} className="crm-bklog__row">
                <span className="crm-bklog__when">{stamp(e.created_at, zone)}</span>
                <span className={`crm-bktag ${tag.cls}`}>{tag.label}</span>
                <span>
                  <b>{s.who}</b> {s.text}
                  {diag ? <small className="crm-bklog__diag">{diag}</small> : null}
                </span>
              </div>
            );
          })
        )}
        {rows && rows.length >= limit ? (
          <button type="button" className="crm-linkact crm-bklog__more" onClick={() => setLimit(limit + 50)}>
            Show earlier
          </button>
        ) : null}
      </div>
    </div>
  );
}
